import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

function FundingBridgePointsRemainingForm({
  fundingStatus,
  totalExpectedBalance,
  remainingBridgePoints,
  expectedBalanceOnClose,
}) {
  const getValue = () => {
    if (fundingStatus === 'CLOSED' || fundingStatus === 'CANCELLED') {
      return '';
    }

    if (totalExpectedBalance) {
      return `${remainingBridgePoints} (Expected)`;
    }

    return remainingBridgePoints || '';
  };

  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Remaining BridgePoints™:</Form.Label>
      </Col>
      <Col md={2} className="bo-same-line">
        <Form.Control
          className={`bo-input ${
            totalExpectedBalance && expectedBalanceOnClose < 0 ? 'bo-text-red' : ''
          }`}
          type="text"
          name="openFundingRemainingBalance"
          id="openFundingRemainingBalance"
          value={getValue()}
          readOnly
        />
      </Col>
      <Col md={2} className="bo-same-line" />
    </>
  );
}

export default memo(FundingBridgePointsRemainingForm);
